// Translation: Account > Profile > General information (Ukrainian)
export default Object.freeze({
	input : {
		label: '',
		placeholder: ''
	},
	title: ''
})
